var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleplay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 39,
    viewBox: "0 0 129 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.506 37.4597H4.82949C2.42558 37.4597 0.475891 35.51 0.475891 33.1061V4.99192C0.475891 2.58701 2.42558 0.638321 4.82949 0.638321H123.506C125.91 0.638321 127.858 2.58701 127.858 4.99192V33.1061C127.858 35.51 125.91 37.4597 123.506 37.4597Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_100",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 129,
    height: 38
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.161728H128.335V37.9352H0V0.161728Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_100)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.82959 1.1138C2.69222 1.1138 0.952181 2.85285 0.952181 4.99121V33.1054C0.952181 35.2438 2.69222 36.9828 4.82959 36.9828H123.506C125.644 36.9828 127.383 35.2438 127.383 33.1054V4.99121C127.383 2.85285 125.644 1.1138 123.506 1.1138H4.82959ZM123.506 37.9352H4.82959C2.16712 37.9352 -0.000199661 35.7689 -0.000199661 33.1054V4.99121C-0.000199661 2.32774 2.16712 0.161423 4.82959 0.161423H123.506C126.168 0.161423 128.336 2.32774 128.336 4.99121V33.1054C128.336 35.7689 126.168 37.9352 123.506 37.9352Z",
    fill: "#A6A8AB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_100",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 129,
    height: 38
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 37.9355H128.335V0.161728H0V37.9355Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_100)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.541 28.6423H103.31V16.7855H101.541V28.6423ZM117.483 21.0572L115.455 26.1975H115.394L113.288 21.0572H111.382L114.539 28.242L112.739 32.2392H114.585L119.451 21.0572H117.483ZM107.445 27.2966C106.865 27.2966 106.058 27.0071 106.058 26.2893C106.058 25.3739 107.064 25.0225 107.933 25.0225C108.711 25.0225 109.078 25.1912 109.551 25.4198C109.413 26.5179 108.468 27.2966 107.445 27.2966ZM107.659 20.7976C106.377 20.7976 105.05 21.3617 104.501 22.6126L106.073 23.2694C106.408 22.6126 107.034 22.3989 107.689 22.3989C108.604 22.3989 109.536 22.948 109.551 23.9243V24.0471C109.23 23.8634 108.543 23.5889 107.705 23.5889C106.012 23.5889 104.288 24.5203 104.288 26.2594C104.288 27.8457 105.675 28.8679 107.232 28.8679C108.422 28.8679 109.078 28.3338 109.49 27.7079H109.551V28.6233H111.259V24.0771C111.259 21.9716 109.689 20.7976 107.659 20.7976ZM96.7216 22.5007H94.2038V18.4357H96.7216C98.0443 18.4357 98.796 19.5308 98.796 20.4682C98.796 21.3866 98.0443 22.5007 96.7216 22.5007ZM96.6756 16.7855H92.4348V28.6423H94.2038V24.1509H96.6756C98.6373 24.1509 100.565 22.7304 100.565 20.4682C100.565 18.2051 98.6373 16.7855 96.6756 16.7855ZM73.5499 27.2986C72.327 27.2986 71.3028 26.2743 71.3028 24.8687C71.3028 23.4471 72.327 22.4089 73.5499 22.4089C74.7569 22.4089 75.7043 23.4471 75.7043 24.8687C75.7043 26.2743 74.7569 27.2986 73.5499 27.2986ZM75.5815 21.7211H75.5206C75.1233 21.2469 74.3596 20.8186 73.3962 20.8186C71.3796 20.8186 69.5308 22.5916 69.5308 24.8687C69.5308 27.1309 71.3796 28.8879 73.3962 28.8879C74.3596 28.8879 75.1233 28.4596 75.5206 27.9714H75.5815V28.5515C75.5815 30.0948 74.7569 30.9204 73.4272 30.9204C72.342 30.9204 71.6701 30.1408 71.3946 29.4839L69.8512 30.1258C70.2945 31.195 71.4715 32.5087 73.4272 32.5087C75.5056 32.5087 77.2626 31.2868 77.2626 28.3069V21.0642H75.5815V21.7211ZM78.4856 28.6423H80.2585V16.7845H78.4856V28.6423ZM82.8711 24.731C82.8252 23.1726 84.078 22.378 84.9795 22.378C85.6823 22.378 86.2783 22.7294 86.477 23.2335L82.8711 24.731ZM88.3717 23.3862C88.0353 22.4848 87.0121 20.8186 84.9186 20.8186C82.8402 20.8186 81.1131 22.4548 81.1131 24.8537C81.1131 27.1149 82.8252 28.8879 85.1173 28.8879C86.9661 28.8879 88.0353 27.7568 88.4786 27.0999L87.1039 26.1835C86.6457 26.8553 86.0187 27.2986 85.1173 27.2986C84.2158 27.2986 83.5739 26.8863 83.1616 26.0757L88.5554 23.8455L88.3717 23.3862ZM45.3968 22.0575V23.7686H49.4919C49.3691 24.731 49.0486 25.4348 48.5594 25.9229C47.9635 26.5189 47.031 27.1768 45.3968 27.1768C42.8751 27.1768 40.9045 25.1443 40.9045 22.6225C40.9045 20.1008 42.8751 18.0693 45.3968 18.0693C46.7565 18.0693 47.7498 18.6034 48.4836 19.2912L49.6905 18.0843C48.6663 17.1059 47.3066 16.3572 45.3968 16.3572C41.9427 16.3572 39.0396 19.1694 39.0396 22.6225C39.0396 26.0757 41.9427 28.8879 45.3968 28.8879C47.2606 28.8879 48.6663 28.2759 49.7664 27.1309C50.8975 25.9998 51.2489 24.4105 51.2489 23.1267C51.2489 22.7294 51.2189 22.363 51.158 22.0575H45.3968ZM55.9049 27.2986C54.682 27.2986 53.6278 26.2903 53.6278 24.8537C53.6278 23.4012 54.682 22.4089 55.9049 22.4089C57.1269 22.4089 58.1821 23.4012 58.1821 24.8537C58.1821 26.2903 57.1269 27.2986 55.9049 27.2986ZM55.9049 20.8186C53.6737 20.8186 51.8548 22.5157 51.8548 24.8537C51.8548 27.1768 53.6737 28.8879 55.9049 28.8879C58.1362 28.8879 59.9541 27.1768 59.9541 24.8537C59.9541 22.5157 58.1362 20.8186 55.9049 20.8186ZM64.7389 27.2986C63.516 27.2986 62.4618 26.2903 62.4618 24.8537C62.4618 23.4012 63.516 22.4089 64.7389 22.4089C65.9609 22.4089 67.0151 23.4012 67.0151 24.8537C67.0151 26.2903 65.9609 27.2986 64.7389 27.2986ZM64.7389 20.8186C62.5077 20.8186 60.6888 22.5157 60.6888 24.8537C60.6888 27.1768 62.5077 28.8879 64.7389 28.8879C66.9691 28.8879 68.788 27.1768 68.788 24.8537C68.788 22.5157 66.9691 20.8186 64.7389 20.8186Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0088 7.34641C9.73325 7.63791 9.57053 8.09114 9.57053 8.67715V29.6385C9.57053 30.2245 9.73325 30.6777 10.0088 30.9702L10.0787 31.0381L21.8197 19.2961V19.1583V19.0196L10.0787 7.27753L10.0088 7.34641Z",
    fill: "#5AC8F2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_100",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 15,
    width: 11,
    height: 9
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8199 19.0187V19.1574V19.2962L25.7332 23.2115L25.8231 23.1606L30.4602 20.5261C31.784 19.7734 31.784 18.5425 30.4602 17.7898L25.8231 15.1542L25.7342 15.1043L21.8199 19.0187Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_100)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8199 19.0187V19.1574V19.2962L25.7332 23.2115L25.8231 23.1606L30.4602 20.5261C31.784 19.7734 31.784 18.5425 30.4602 17.7898L25.8231 15.1542L25.7342 15.1043L21.8199 19.0187Z",
    fill: "url(#paint0_linear_0_100)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_0_100",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 19,
    width: 16,
    height: 13
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.009 30.9693C10.4452 31.4326 11.166 31.4885 11.9786 31.0272L25.8231 23.1606L21.8199 19.1574L10.009 30.9693Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_0_100)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.009 30.9693C10.4452 31.4326 11.166 31.4885 11.9786 31.0272L25.8231 23.1606L21.8199 19.1574L10.009 30.9693Z",
    fill: "url(#paint1_linear_0_100)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_0_100",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 6,
    width: 16,
    height: 14
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.009 7.34652L21.8199 19.1574L25.8231 15.1542L11.9786 7.28862C11.5973 7.07199 11.2369 6.97016 10.9164 6.97016C10.5531 6.96916 10.2406 7.10094 10.009 7.34652Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_0_100)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.009 7.34652L21.8199 19.1574L25.8231 15.1542L11.9786 7.28862C11.5973 7.07199 11.2369 6.97016 10.9164 6.97016C10.5531 6.96916 10.2406 7.10094 10.009 7.34652Z",
    fill: "url(#paint2_linear_0_100)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5962 8.01668C43.2408 7.70122 42.7706 7.49856 42.2525 7.49856C41.0854 7.49856 40.187 8.46192 40.187 9.64491C40.187 10.8269 41.0854 11.7823 42.2525 11.7823C43.2568 11.7823 43.9855 11.1993 44.0334 10.2758H42.4471V9.61995H44.892C44.892 11.5806 43.8477 12.5041 42.2525 12.5041C40.6642 12.5041 39.4343 11.2242 39.4343 9.64491C39.4343 8.05761 40.6642 6.77779 42.2525 6.77779C42.9892 6.77779 43.6531 7.0613 44.1393 7.51453L43.5962 8.01668Z",
    fill: "#FEFEFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2262 6.84238V7.54718H46.6745V9.32915H48.9018V10.034H46.6745V11.7181H49.3071V12.4229H45.9218V6.84238H49.2262Z",
    fill: "#FEFEFE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1105 6.84238V7.55516H52.4174V12.4229H51.6567V7.55516H49.9636V6.84238H54.1105Z",
    fill: "#FEFEFE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9711 12.4229H57.7239V6.84238H56.9711V12.4229Z",
    fill: "#FEFEFE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.8583 6.84238V7.55516H61.1662V12.4229H60.4045V7.55516H58.7114V6.84238H62.8583Z",
    fill: "#FEFEFE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1726 11.7744C69.3466 11.7744 70.2461 10.827 70.2461 9.645C70.2461 8.46201 69.3466 7.50664 68.1726 7.50664C67.0066 7.50664 66.1071 8.46201 66.1071 9.645C66.1071 10.827 67.0066 11.7744 68.1726 11.7744ZM68.1726 6.77788C69.7679 6.77788 71.0068 8.0567 71.0068 9.645C71.0068 11.2243 69.7679 12.5031 68.1726 12.5031C66.5853 12.5031 65.3534 11.2243 65.3534 9.645C65.3534 8.0567 66.5853 6.77788 68.1726 6.77788Z",
    fill: "#FEFEFE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.4624 12.4227L72.9197 8.21982V12.4227H72.166V6.84216H72.9117L75.4305 11.0131V6.84216H76.1832V12.4227H75.4624Z",
    fill: "#FEFEFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_100",
    x1: 29.5989,
    y1: 9.50834,
    x2: 6.66675,
    y2: 9.50834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_100",
    x1: 9.6558,
    y1: 13.0208,
    x2: -5.44139,
    y2: 38.4341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE4547"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7186D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_100",
    x1: -9.44264,
    y1: 2.10357,
    x2: 2.88116,
    y2: 22.8537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73C169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#289E6F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/google play.53e239ad2a8dc2243539340277794c1e.svg";
export { ForwardRef as ReactComponent };